export class Order {
  name: string;
  direction: 'asc' | 'desc';

  constructor(data?: any) {
    this.name = (data && data.name) || null;
    this.direction = (data && data.direction) || null;
  }
}
